module.exports = __webpack_public_path__ + "static/media/Logo_Gulali_Festival.bcce2948.png";